import React from 'react';
import { Popover } from 'antd';

const content =
    <div className="graph-popover">
        The number of your colleagues who have this person on their contact lists.
    </div>;

export class ContactIconHeader extends React.Component {
    render() {
        return (
            <Popover content={content} trigger="hover" placement="bottom">
                <div className="icon-contact right" />
            </Popover>
        );
    }
}